module.exports = __webpack_public_path__ + "static/media/assinantes_session.ae082438.png";